import { BID_REQUEST_STATUS_ENUM, BID_REQUEST_TYPE_ENUM, FILE_TYPE_ENUM, FileRule } from "interfaces";
import { fileExistsInObject } from "utils";

export interface FileRulesParams {
  status: string;
  type: string;
  documents: Record<string, any[]>;
  isAnyOperator: boolean;
  isCustomer: boolean;
  isProvider: boolean;
  isOperator: boolean;
  isSeniorCustomer: boolean;
  isSeniorOperator: boolean;
}

export const getFileRules = ({
  status,
  type,
  documents,
  isAnyOperator,
  isCustomer,
  isProvider,
  isOperator,
  isSeniorCustomer,
  isSeniorOperator,
}: FileRulesParams): FileRule[] => {
  const bidIsDraft = status === BID_REQUEST_STATUS_ENUM.DRAFT;
  const bidIsAgentProposal = status === BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL;
  const bidWithAgent = type === BID_REQUEST_TYPE_ENUM.REQUEST_WITH_AGENT;

  return [
    {
      type: FILE_TYPE_ENUM.INVOICE,
      label: "Инвойс",
      canUpload: (isCustomer && bidIsDraft) || isOperator,
      canRemove: (isSeniorCustomer && bidIsDraft) || isSeniorOperator,
      visible: isAnyOperator || isCustomer,
      multipleUpload: {
        canLoadAgain: false,
        multiple: true,
      },
    },
    {
      type: FILE_TYPE_ENUM.AGENT_CONTRACT,
      label: "Агентский договор",
      canUpload: isOperator && bidIsDraft && bidWithAgent,
      canRemove: isSeniorOperator && bidIsDraft && bidWithAgent,
      visible: (isAnyOperator || isCustomer) && (bidIsDraft || bidIsAgentProposal),
      multipleUpload: {
        canLoadAgain: false,
        multiple: false,
      },
    },
    {
      type: FILE_TYPE_ENUM.AGENT_ASSIGNMENT,
      label: "Агентское поручение",
      canUpload: isOperator && bidIsDraft && bidWithAgent,
      canRemove: isSeniorOperator && bidIsDraft && bidWithAgent,
      visible: (isAnyOperator || isCustomer) && (bidIsDraft || bidIsAgentProposal),
      multipleUpload: {
        canLoadAgain: false,
        multiple: false,
      },
    },
    {
      type: FILE_TYPE_ENUM.AGENT_CONTRACT_SIGNED,
      label: `Агентский договор${bidIsDraft || bidIsAgentProposal ? ", подписанный" : ""}`,
      canUpload: (isOperator || isCustomer) && bidIsAgentProposal,
      canRemove: (isSeniorCustomer || isSeniorOperator) && bidIsAgentProposal,
      visible: (isAnyOperator || isCustomer) && fileExistsInObject(documents, FILE_TYPE_ENUM.AGENT_CONTRACT),
      multipleUpload: {
        canLoadAgain: false,
        multiple: false,
      },
    },
    {
      type: FILE_TYPE_ENUM.AGENT_ASSIGNMENT_SIGNED,
      label: `Агентское поручение${bidIsDraft || bidIsAgentProposal ? ", подписанное" : ""}`,
      canUpload: (isOperator || isCustomer) && bidIsAgentProposal,
      canRemove: (isSeniorCustomer || isSeniorOperator) && bidIsAgentProposal,
      visible: (isAnyOperator || isCustomer) && fileExistsInObject(documents, FILE_TYPE_ENUM.AGENT_ASSIGNMENT),
      multipleUpload: {
        canLoadAgain: false,
        multiple: false,
      },
    },
    {
      type: FILE_TYPE_ENUM.DKP,
      label: "Договор купли-продажи ЦВ",
      canUpload: false,
      canRemove: false,
      visible: true,
      multipleUpload: {
        canLoadAgain: false,
        multiple: false,
      },
    },
    {
      type: FILE_TYPE_ENUM.PP_CUSTOMER,
      label: isAnyOperator ? "Поручение УВЭД" : "Поручение на исполнение",
      canUpload: false,
      canRemove: false,
      visible: isCustomer || isAnyOperator,
      multipleUpload: {
        canLoadAgain: false,
        multiple: false,
      },
    },
    {
      type: FILE_TYPE_ENUM.PP_LP,
      label: isAnyOperator ? "Поручение ПЛ" : "Поручение на исполнение",
      canUpload: false,
      canRemove: false,
      visible: isProvider || isAnyOperator,
      multipleUpload: {
        canLoadAgain: false,
        multiple: false,
      },
    },
  ];
};
